import { BalanceTargetType } from 'types';
import { settlementTexts } from 'consts/text';

export const childBalanceTargetTypeLabels: Record<BalanceTargetType, string> = {
    [BalanceTargetType.PARENT]: settlementTexts.children.balanceTargetTypes.parentOrLegalGuardian,
    [BalanceTargetType.FOUNDATION]: settlementTexts.children.balanceTargetTypes.anotherEntity,
    [BalanceTargetType.CATERING]: settlementTexts.children.balanceTargetTypes.catering,
};
